module.exports = {
	"client": "tec-ldh",
	"client_fullname": "La Dernière Heure",
	"version": "0.0.0.10",
	"production_url": "tec-ldh-webreader-production.twipemobile.com",
	"uat_url": "tec-ldh-webreader-uat.twipemobile.com",
	"production_api": "tec-ldh-production-backend-api.twipecloud.net",
	"uat_api": "tec-ldh-uat-backend-api.twipecloud.net",
	"html_title": "La Dernière Heure",
	"nextgen": false,
	"replica": true
};


//////////////////
// WEBPACK FOOTER
// ./clients/tec-ldh/package.json
// module id = 133
// module chunks = 0 1